<div class="element-type-list-section">
  <div class="section-title">Structure Type</div>
  <div class="element-type-list" role="listbox" aria-label="Structure Type" [attr.aria-multiselectable]="multiple || null">
    <button
      type="button"
      class="element-type-item"
      *ngFor="let type of elementTypes"
      [class.selected]="isSelected(type)"
      [attr.aria-selected]="isSelected(type)"
      role="option"
      (click)="onTypeClick(type)"
    >
      <span>{{ type }}</span>
    </button>
  </div>

  <div class="projection-toggle" *ngIf="isProjectionToggleVisible">
    <mat-slide-toggle
      [checked]="useFrontProjection"
      (change)="setUseFrontProjection($event.checked)"
    >
      Front-facing projection
    </mat-slide-toggle>
    <div class="projection-hint">
      Generates the area as if viewed from directly in front of the element
    </div>
  </div>
</div>
